import { render } from "./npxForm.vue?vue&type=template&id=83e122c0&ts=true"
import script from "./npxForm.vue?vue&type=script&lang=ts"
export * from "./npxForm.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\Vue\\donaska-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__